import RadioTile from './RadioTile';
export type { RadioTileProps, ValueType } from './RadioTile';

export default RadioTile;
